import {DirectiveOptions} from 'vue';

// 正数
const positiveNumber: DirectiveOptions = {
  bind(el: HTMLElement): void {
    el.addEventListener('input', (e: Event): void => {
      let value = (e.target as HTMLInputElement).value;
      if (value.indexOf(',') > -1) {
        value = value.replace(',', '');
      }
      if (Number.isNaN(Number(value))) {
        value = '0';
      }
      (e.target as HTMLInputElement).value = value.replace('-', '');
    });
  }
};
export default positiveNumber;
